import { useEffect, useState } from "react";
import axios, { apiBaseUrl } from "../../api/axios";
import ResponsiveTable from "../../components/ResponsiveTable";
import Loader from "../../components/Loader";
import { EyeIcon, PencilIcon, TrashIcon, CurrencyDollarIcon } from "@heroicons/react/24/outline";
import ExportButtons from "../../components/ExportButtons";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "../../components/Modal";

export default function CategoryList() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [itemId, setItemId] = useState(null);
    const [name, setName] = useState('')
    const closeModal = () => {
        setName('')
        setItemId(null)
        setIsModalOpen(false)
    };
    const [expensesList, setExpensesList] = useState([])
    const getSingleData = (id) => {
        axios.get(`/meta/categories/${id}`).then((res) => {
            setName(res.data?.name)
            console.log(res.data);
        });
    }
    const getCategoryData = () => {
        axios.get("/meta/categories").then((res) => {
            setExpensesList(res.data);
        });
    }
    useEffect(() => {
        getCategoryData()
    }, []);
    const handleSubmit = () => {
        setLoading(true)
        setIsModalOpen(false)
        const payload = {
            name: name,
        }
        const apiUrl = itemId !== null
            ? `/meta/categories/${itemId}`  // Update endpoint
            : '/meta/categories';           // Create endpoint

        const apiCall = itemId
            ? axios.put(apiUrl, payload)                   // Use PUT for update
            : axios.post(apiUrl, payload);                 // Use POST for create

        apiCall
            .then(res => {
                toast.success(res.data?.message || `Category ${itemId !== null ? 'updated' : 'created'} successfully!`)
                setLoading(false)
                getCategoryData()
                navigate('/item/categories')
                setName('')
                setItemId(null)
            })
            .catch(err => {
                setLoading(false)
                toast.error(err.message || `Error`)
            });
    }
    const actions = [
        { label: 'Edit', value: 'edit', icon: <PencilIcon className="w-4 h-4 inline" /> },
        { divider: true },
        { label: 'Delete', value: 'delete', icon: <TrashIcon className="w-4 h-4 inline text-red-600" /> },
    ];
    const handleActionClick = (action, row) => {
        switch (action) {
            case "edit":
                setItemId(row.id)
                getSingleData(row.id)
                setIsModalOpen(true)
                break;
            case "delete":
                if (window.confirm("Are you sure you want to delete this Category?")) {
                    axios.delete(`/meta/categories/${row.id}`).then(() => {
                        getCategoryData()
                    });
                }
                break;
            default:
                break;
        }
    };
    const handleDownload = (type) => {
        const url = `${apiBaseUrl}/purchases/export/${type}`;
        window.open(url, "_blank");
    };
    const columns = [
        {
            header: "SL",
            accessor: "sl",
            render: (value, row, index) => index + 1, // index is passed via render in your table
        },
        { header: "Category Name", accessor: "name" },
    ];

    return (
        <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
            <div className="w-full">
                <ExportButtons title="Category List" onDownload={handleDownload} />
                <div className="flex justify-end">
                    <button
                        onClick={() => setIsModalOpen(true)}
                        className=" bg-purple-600 text-white px-4 py-1 rounded text-sm"
                    >
                        + Add New
                    </button>
                </div>
                <ResponsiveTable
                    columns={columns}
                    data={expensesList}
                    showActions
                    actionButtons={actions}
                    onActionClick={handleActionClick}
                />
            </div>
            {/* Modal */}
            <Modal
                isOpen={isModalOpen}
                onClose={closeModal}
                modalWidth="max-w-md"
                header={<span className="text-blue-600">Add/Update Category</span>}
                body={
                    <div className="mb-3">
                        <label className="font-semibold text-sm">Name</label>
                        <input
                            type="text"
                            value={name}
                            placeholder='Enter name'
                            onChange={(e) => {
                                setName(e.target.value)
                            }}
                            className='border w-full rounded mt-1'
                        />

                    </div>
                }
                footer={
                    <div className="flex gap-2">
                        <button
                            onClick={closeModal}
                            className="px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
                        >
                            Close
                        </button>
                        <button
                            onClick={() => handleSubmit()}
                            className="px-4 py-2 text-white bg-green-700 rounded hover:bg-green-800"
                        >
                            Save
                        </button>
                    </div>
                }
            />
            <Loader show={loading} />
        </div>
    );
}